import React, { useEffect, useState } from "react";
import { cn } from "../lib/helpers";
import ContactForm from "./contactForm";

import * as styles from "./formMain.module.css";
import * as commonStyles from "../styles/common.module.css";

// Links to this page carry the service of interest as the whole query string, e.g. /konzultace?Ulthera
function useQueryAction() {
  const [action, setAction] = useState("");

  useEffect(() => {
    const query = window.location.search.slice(1);
    if (!query) return;
    try {
      setAction(decodeURI(query));
    } catch {
      setAction(query);
    }
  }, []);

  return action;
}

function FormMain() {
  const action = useQueryAction();

  return (
    <div>
      <h1 className={cn(styles.headline, commonStyles.colorAccent, commonStyles.fontButlerMedium)}>
        Konzultace
      </h1>
      <div className={styles.formContainer}>
        {action && (
          <h3
            className={cn(styles.title, commonStyles.colorDarkGray, commonStyles.fontButlerMedium)}
          >
            {`Jsme rádi, že máte zájem o: `}
            <span
              className={cn(commonStyles.colorAccent, commonStyles.fontButlerMedium)}
            >{`${action}.`}</span>
          </h3>
        )}
        <h3
          className={cn(styles.title, commonStyles.colorDarkGray, commonStyles.fontButlerMedium)}
        >{`Nechte nám prosím na sebe kontakt, naše recepční se Vám ozve.`}</h3>
        <ContactForm action={action} />
        <a
          title="BBClinic Shop"
          className={cn(styles.link, commonStyles.colorAccent, commonStyles.fontButlerMedium)}
          target="_blank"
          rel="noopener noreferrer"
          href="https://shop.bbclinic.cz/konzultace"
        >
          Nebo si rovnou kupte poukaz na ošetření.
        </a>
      </div>
    </div>
  );
}

export default FormMain;
